module.exports = __webpack_public_path__ + "static/media/4@720w.8670fb4d.jpg";